import GridShape from "../../components/common/GridShape";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface AuthLayoutProps {
  children: React.ReactNode;
  right?: React.ReactNode;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children, right }) => {
  const { t } = useTranslation();

  return (
    <div className="relative bg-white z-10 dark:bg-gray-900">
      <div className="relative flex flex-col w-full min-h-screen lg:flex-row dark:bg-gray-900">
        {children}

        {right ? (
          <div className="items-center hidden w-full min-h-screen lg:w-1/2 lg:grid" style={{ backgroundColor: '#055590ff' }}>
            <div className="relative flex items-center justify-center z-10 p-12">
              {right}
            </div>
          </div>
        ) : (
          <div className="items-center hidden w-full min-h-screen lg:w-1/2 lg:grid relative overflow-hidden" style={{ backgroundColor: '#055590ff' }}>
            {/* Decorative elements */}
            <div className="absolute inset-0 opacity-10">
              <div className="absolute top-20 left-20 w-72 h-72 bg-white rounded-full blur-3xl"></div>
              <div className="absolute bottom-20 right-20 w-96 h-96 bg-emerald-300 rounded-full blur-3xl"></div>
            </div>
            
            <div className="relative flex items-center justify-center z-10 p-12">
              <div className="flex flex-col items-center max-w-lg text-center">
                <Link to="/" className="block mb-8">
                  <img
                    width={200}
                    height={60}
                    src="/images/logo/logo-dark.svg"
                    alt="Logrit.Life"
                    className="drop-shadow-lg"
                  />
                </Link>
                
                <h2 className="text-3xl font-bold text-white mb-4">
                  {t("authLayout.title")}
                </h2>
                
                <p className="text-lg text-white/90 mb-8 leading-relaxed">
                  {t(
                    "authLayout.description",
                    t("authLayout.description")
                  )}
                </p>

                <div className="grid grid-cols-1 gap-4 w-full max-w-md">
                  <div className="flex items-start gap-3 text-left">
                    <div className="flex-shrink-0 w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center">
                      <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                    <div>
                      <h3 className="text-white font-semibold mb-1">
                        {t("authLayout.feature1Title")}
                      </h3>
                      <p className="text-white/80 text-sm">
                        {t("authLayout.feature1Desc")}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3 text-left">
                    <div className="flex-shrink-0 w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center">
                      <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                      </svg>
                    </div>
                    <div>
                      <h3 className="text-white font-semibold mb-1">
                        {t("authLayout.feature2Title")}
                      </h3>
                      <p className="text-white/80 text-sm">
                        {t("authLayout.feature2Desc")}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3 text-left">
                    <div className="flex-shrink-0 w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center">
                      <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                      </svg>
                    </div>
                    <div>
                      <h3 className="text-white font-semibold mb-1">
                        {t("authLayout.feature3Title")}
                      </h3>
                      <p className="text-white/80 text-sm">
                        {t("authLayout.feature3Desc")}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AuthLayout;
